var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { "grid-list-sm": "", fluid: "" } },
        [
          _c(
            "v-form",
            { ref: "AmazonLauncherForm" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "dense_input mb-3",
                        attrs: {
                          outline: "",
                          dense: "",
                          rules: [_vm.required],
                          label: "Type*",
                          clearable: "",
                          items: _vm.package_types
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters.package_type,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "package_type", $$v)
                          },
                          expression: "form.parameters.package_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dense_input mb-3",
                        attrs: {
                          outline: "",
                          rules: [_vm.required],
                          label: "Titre*"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters.title,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "title", $$v)
                          },
                          expression: "form.parameters.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dense_input mb-3",
                        attrs: {
                          outline: "",
                          rules: [_vm.required],
                          label: "Label*"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters.label,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "label", $$v)
                          },
                          expression: "form.parameters.label"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "title" },
                [
                  _vm._v("\n\t\t\t\tSélection des assets\n\t\t\t\t"),
                  _vm.nbAssets > 0
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "my-0",
                          attrs: {
                            label: "",
                            small: "",
                            outline: "",
                            color: "primary"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.nbAssets) +
                              " selectionnés\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.nbAssets > 0
                ? _c(
                    "div",
                    _vm._l(_vm.form.parameters.assets.list, function(
                      asset,
                      assetIndex
                    ) {
                      return _c(
                        "div",
                        {
                          key: asset.filepath,
                          staticClass: "asset-section elevation-4"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "caption d-block" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: { flat: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeAsset(assetIndex)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              ),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(asset.filepath) +
                                  "\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "dense_input",
                                    attrs: {
                                      outline: "",
                                      dense: "",
                                      rules: [_vm.required],
                                      label: "Type",
                                      clearable: "",
                                      items: _vm.asset_types
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onAssetTypeChange(assetIndex)
                                      }
                                    },
                                    model: {
                                      value: asset.asset_type,
                                      callback: function($$v) {
                                        _vm.$set(asset, "asset_type", $$v)
                                      },
                                      expression: "asset.asset_type"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _vm.showRole(asset.asset_type)
                                    ? _c("v-autocomplete", {
                                        staticClass: "dense_input",
                                        attrs: {
                                          outline: "",
                                          dense: "",
                                          rules: [],
                                          label: "Rôle",
                                          clearable: "",
                                          items: _vm.asset_roles
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.emitChange()
                                          }
                                        },
                                        model: {
                                          value: asset.role,
                                          callback: function($$v) {
                                            _vm.$set(asset, "role", $$v)
                                          },
                                          expression: "asset.role"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              asset.asset_type
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs5: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dense_input input-lg",
                                        attrs: {
                                          clearable: "",
                                          label: "Langue",
                                          outline: "",
                                          rules: [],
                                          dense: "",
                                          items: _vm.languages,
                                          "item-text": "text",
                                          "item-value": "code"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.emitChange()
                                          }
                                        },
                                        model: {
                                          value: asset.language,
                                          callback: function($$v) {
                                            _vm.$set(asset, "language", $$v)
                                          },
                                          expression: "asset.language"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  asset.asset_type === "Audio"
                                    ? _c("v-autocomplete", {
                                        staticClass: "dense_input",
                                        attrs: {
                                          outline: "",
                                          dense: "",
                                          clearable: "",
                                          rules: [],
                                          label: "Audio Type",
                                          items: _vm.audio_types
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.emitChange()
                                          }
                                        },
                                        model: {
                                          value: asset.audio_type,
                                          callback: function($$v) {
                                            _vm.$set(asset, "audio_type", $$v)
                                          },
                                          expression: "asset.audio_type"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  asset.asset_type === "Subtitle"
                                    ? _c("v-autocomplete", {
                                        staticClass: "dense_input",
                                        attrs: {
                                          outline: "",
                                          dense: "",
                                          clearable: "",
                                          rules: [],
                                          label: "Subtitle Type",
                                          items: _vm.subtitle_types
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.emitChange()
                                          }
                                        },
                                        model: {
                                          value: asset.subtitle_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              asset,
                                              "subtitle_type",
                                              $$v
                                            )
                                          },
                                          expression: "asset.subtitle_type"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "mt-3 mb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      ref: "explorer_btn",
                      staticClass: "mt-0 mx-1 color--text text-none",
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.showExplorer = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v("\n\t\t\t\t\tFichiers via le filesystem\n\t\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      ref: "asset_finder_btn",
                      staticClass: "mt-0 mx-1 color--text text-none",
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.showAssetFinder = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v("\n\t\t\t\t\tFichiers via asset finder\n\t\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-width": 200,
                        "offset-x": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "text-none mt-0 mx-1",
                                    attrs: {
                                      small: "",
                                      flat: "",
                                      color: "primary"
                                    }
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { staticClass: "mr-1" }, [
                                    _vm._v("help_outline")
                                  ]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tNomenclature pour auto-remplissage\n\t\t\t\t\t\t"
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.naming_help_menu,
                        callback: function($$v) {
                          _vm.naming_help_menu = $$v
                        },
                        expression: "naming_help_menu"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "background darken-1" },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "pa-2" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "title",
                                  attrs: {
                                    href: _vm.nomenclature_spec,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { color: "primary" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\topen_in_new\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tSpécifications Amazon\n\t\t\t\t\t\t\t"
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: { flat: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.naming_help_menu = false
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-card-text", { staticClass: "pa-2" }, [
                            _c("table", { staticClass: "naming-table" }, [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "subheading background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t[PartnerAlias]\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "subheading background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t[UniqueID]\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("[ContentType]")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("[AssetType]")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("[LanguageCode]")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("[Territory]")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "subheading background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t[OtherInformation]\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(".")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "subheading background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\txxx\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tNon utilisé\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tNon utilisé\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Full")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tRôle = Feature\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Trailer")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tRôle = Trailer\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Mezz")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Video\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Dubcard")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Dubcard\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Audio")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Audio\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\taudio_type = primary\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Audio_Narration")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Audio\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\taudio_type = narration\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Audio_Dialog")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Audio\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\taudio_type = dialog centric\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Audio_Commentary")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Audio\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\taudio_type = commentary\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Caption")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Subtitle")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Subtitle\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tsubtitle_type = Normal\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Caption_sdh")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Subtitle_sdh")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Subtitle\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tsubtitle_type = SDH\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Caption_Forced")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "primary--text" }, [
                                    _vm._v("Subtitle_Forced")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\ttype = Subtitle\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "background lighten-4"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tsubdirectory_arrow_right\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tsubtitle_type = Forced\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [_vm._v("Requis")]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [_vm._v("Requis")]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "background--text text--lighten-4"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tNon utilisé\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td")
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.nbAssets > 0
                    ? _c(
                        "v-btn",
                        {
                          ref: "removeFiles_btn",
                          staticClass: "mt-0 mx-1 color--text text-none",
                          attrs: { color: "warning", small: "" },
                          on: {
                            click: function($event) {
                              _vm.form.parameters.assets.list = []
                              _vm.emitChange()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("close")
                          ]),
                          _vm._v("\n\t\t\t\t\tSuppprimer les assets\n\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2 mb-3" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.form,
                  options: { maxDepth: 3, rootObjectKey: "Output" }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.wf_data,
                  options: { maxDepth: 0, rootObjectKey: "Job Descriptor" }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExplorer
        ? _c("Explorer", {
            attrs: {
              assetType: "file",
              multiselect: true,
              toolbarTitle:
                "Selectionnez des assets présents sur le filesystem",
              no_previous_path: true
            },
            on: {
              close: function($event) {
                _vm.showExplorer = false
              },
              selectedAssets: function($event) {
                return _vm.addAssets($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAssetFinder
        ? _c("AssetFinder", {
            attrs: {
              multiselect: true,
              toolbarTitle: "Selectionnez des assets via asset finder"
            },
            on: {
              close: function($event) {
                _vm.showAssetFinder = false
              },
              selectedAssets: function($event) {
                return _vm.addAssets($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5587db8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5587db8f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_amazon_package_global.vue
// module id = null
// module chunks = 